// Copyright 1999-2017. Plesk International GmbH. All rights reserved.
/* eslint-disable react/prefer-stateless-function */

import { createElement, cloneElement, Component } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import FormField from '../FormField';
import Hint from '../Hint';
import Radio from '../Radio';

import './FormFieldRadioButtons.less';

/**
 * `FormFieldRadioGroup` are used for making a choice among a set of mutually exclusive, related options. Only one option can be chosen.
 */
class FormFieldRadioButtons extends Component {
    render() {
        const {
            baseClassName,
            className,
            options,
            disabled: fieldDisabled,
            ...props
        } = this.props;

        return (
            <FormField className={classNames(baseClassName, className)} {...props}>
                {({ getId, getName, getValue, setValue }) => options.map(({ value, label, description, disabled, indentFields = [] }) => (
                    <Radio
                        key={value}
                        name={getName()}
                        label={label || value}
                        checked={getValue() === value}
                        onChange={isChecked => {
                            if (isChecked) {
                                setValue(value);
                            }
                        }}
                        disabled={fieldDisabled || disabled}
                        inputProps={{ id: getId() ? `${getId()}-${value}` : null, name: getName(), value }}
                    >
                        {description ? <Hint className={`${FormField.defaultProps.baseClassName}__description`}>{description}</Hint> : null}
                        {indentFields.map(field => (fieldDisabled || disabled || getValue() !== value) ? cloneElement(field, { disabled: true }) : field)}
                    </Radio>
                ))}
            </FormField>
        );
    }
}
FormFieldRadioButtons.propTypes = {
    /**
     * Options definition.
     */
    options: PropTypes.arrayOf(PropTypes.shape({
        /**
         * Option value.
         */
        value: PropTypes.string.isRequired,
        /**
         * Option label.
         */
        label: PropTypes.node.isRequired,
        /**
         * Text hint located below option for providing additional information.
         */
        description: PropTypes.node,
        /**
         * Set true if option is not available to choice.
         */
        disabled: PropTypes.bool,
        /**
         * Optional array of `FormField` components under this option.
         */
        indentFields: PropTypes.array,
    })).isRequired,
    /**
     * Value of current chosen option.
     */
    value: PropTypes.string.isRequired,
    /**
     * Disabled state of field.
     */
    disabled: PropTypes.bool,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
FormFieldRadioButtons.defaultProps = {
    disabled: false,
    className: undefined,
    baseClassName: `${CLS_PREFIX}form-field-radio-buttons`,
};

export default FormFieldRadioButtons;



// WEBPACK FOOTER //
// ./components/FormFieldRadioButtons/FormFieldRadioButtons.js